// extracted by mini-css-extract-plugin
export default {"root":"PageHeading_root__+VvLR","longLetter":"PageHeading_longLetter__O7FE7"};